/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
/*! jQuery v3.6.0 | (c) OpenJS Foundation and other contributors | jquery.org/license */

window.addEventListener('load', function() {
  class PredictiveSearch {

    constructor(element) {
      this.predictiveSearchForm = element;
      this.predictiveSearchInput = this.predictiveSearchForm.querySelector('.live-search-form-field');
      this.predictiveSearchResultContainer = this.predictiveSearchForm.querySelector('.search-flydown');
      this.predictiveInputTimer = null;

      this.initializer();
    }

    initializer() {
      this.bindEvent(this.predictiveSearchInput, 'keyup', this.searchInputChange);
      this.bindEvent(this.predictiveSearchInput, 'blur', this.searchResultHide);
    }

    bindEvent(element, event, method) {
      element.addEventListener(event, method.bind(this));
    }

    searchInputChange(event) {
      let queryString = event.target.value;
      clearTimeout(this.predictiveInputTimer);
      this.predictiveInputTimer = setTimeout(this.renderSearchResult.bind(this), 300, queryString);
    }
    
    searchResultHide() {
      setTimeout(function() {
        this.predictiveSearchResultContainer.classList.remove('visible');
      }, 300, this);
    }

    async renderSearchResult(queryString) {
      if (queryString.trim().length == 0) {
      	return false;
      }
      let searchResult = await this.fetchSearchResult(queryString);
      searchResult = searchResult.resources.results;
      
      let productResultHtml = `<div class="search-flydown--product-items">`;
      searchResult.products.slice(-5).forEach((product, index) => {
        
        productResultHtml += `
			<a class="search-flydown--product search-flydown--product" href="${product.url}">
				<div class="search-flydown--product-image">
					<img src="${product.featured_image.url}" alt="${product.featured_image.alt}">
				</div>
				<div class="search-flydown--product-text"><span class="search-flydown--product-title">${product.title}</span><span class="search-flydown--product-price">$${product.price}</span></div>
			</a>
		`;
      	console.log(product.title);
      });
      productResultHtml += "</div>";
      
      let productContentHtml = `<div class="search-flydown--content-items">`;
      productContentHtml += `<h5 class="search-flydown--content-title">Pages & Posts</h5>`;
      productContentHtml += `<ul class="search-flydown--content-items-list">`
      searchResult.pages.forEach((page, index) => {
        productContentHtml += `<li class="search-flydown--content-item"><a href="${page.url}">${page.title}</a></li>`;
      });
      searchResult.articles.forEach((article, index) => {
        productContentHtml += `<li class="search-flydown--content-item"><a href="${article.url}">${article.title}</a></li>`;
      });
      productContentHtml += `</ul>`;
      productContentHtml += `</div>`;
      
      this.predictiveSearchResultContainer.innerHTML = `${productResultHtml}${productContentHtml}<div class="search-flydown--footer"><a class="search-flydown--continue" href="/search?q=${queryString}*&amp;type=article,page,product">View all results</a></div>`;
      this.predictiveSearchResultContainer.classList.add('visible');
      
      console.log(queryString);
      console.log(searchResult);
    }

    async fetchSearchResult(queryString) {
      return await fetch(`/search/suggest.json?q=${queryString}*&resources[type]=product,page,article&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`)
      .then((response) => {
        return response.json();
      });
    }
  };

  var onLoad = function() {
    document.querySelectorAll('.live-search-form').forEach(ele => {
      new PredictiveSearch(ele);
    });
  }

  onLoad();

});

